import PageDataLoader from '../../lib/page-data/loader';
import PageKey from '../../lib/page-data/key';
import {
  CLUB_EVENT_REQUEST,
  CLUB_EVENT_RECEIVE,
  CLUB_EVENT_FAILURE,
  CLUB_EVENT_ATTENDANCE_REQUEST,
  CLUB_EVENT_ATTENDANCE_RECEIVE,
  CLUB_EVENT_ATTENDANCE_FAILURE,
  CLUB_EVENT_SET_ATTENDANCE_REQUEST,
  CLUB_EVENT_SET_ATTENDANCE_SUCCESS,
  CLUB_EVENT_SET_ATTENDANCE_FAILURE,
  PAGE_DATA_LOAD,
} from '../action-types';
import ApiRequestException from '../../exceptions/api-request-exception';

export const fetchClubEvent = (clubId, eventId, request) => async (dispatch) => {
  try {
    dispatch({ type: CLUB_EVENT_REQUEST, payload: { clubId, eventId } });
    const pageKey = new PageKey(clubId, 'club_event', { id: eventId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { attendees, event } = pageData.data;
    dispatch({
      type: CLUB_EVENT_RECEIVE,
      payload: { clubId, eventId, event, attendees },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }
    dispatch({
      type: CLUB_EVENT_FAILURE,
      payload: { clubId, eventId, statusCode, error },
    });
    return { error };
  }
};

export const fetchAttendance = (clubId, eventId) => async (dispatch) => {
  try {
    dispatch({
      type: CLUB_EVENT_ATTENDANCE_REQUEST,
      payload: { clubId, eventId },
    });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/club-website/${clubId}/event/${eventId}/attendance`,
    );
    if (response.status !== 200) {
      dispatch({
        type: CLUB_EVENT_ATTENDANCE_FAILURE,
        payload: {
          clubId,
          error: new ApiRequestException('Error retrieving attendance', response.status),
          eventId,
        },
      });
      return;
    }

    const data = await response.json();
    dispatch({
      type: CLUB_EVENT_ATTENDANCE_RECEIVE,
      payload: { clubId, eventId, attendances: data },
    });
  } catch (error) {
    dispatch({
      type: CLUB_EVENT_ATTENDANCE_FAILURE,
      payload: { clubId, error, eventId },
    });
  }
};

export const updateAttendance = (clubId, eventId, isAttending, member) => async (dispatch) => {
  try {
    dispatch({
      type: CLUB_EVENT_SET_ATTENDANCE_REQUEST,
      payload: { clubId, eventId, isAttending, member },
    });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/clubs/${clubId}/events/${eventId}/attendance?acting_as=${member.memberId}`,
      {
        method: 'POST',
        body: JSON.stringify({ attending: isAttending }),
      },
    );
    if (response.status === 200) {
      dispatch({
        type: CLUB_EVENT_SET_ATTENDANCE_SUCCESS,
        payload: { clubId, eventId, isAttending, member },
      });
    } else {
      dispatch({
        type: CLUB_EVENT_SET_ATTENDANCE_FAILURE,
        payload: {
          clubId,
          error: new ApiRequestException('Error setting attendance', response.status),
          eventId,
          isAttending,
          member,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: CLUB_EVENT_SET_ATTENDANCE_FAILURE,
      payload: { clubId, error, eventId, isAttending, member },
    });
  }
};
